/**
 * /dashboard — Founder Dashboard (Phase 12 / M10).
 *
 * Replaces the placeholder /dashboard route that redirected to /boards.
 * When the user opts into "Use dashboard as landing" in Settings →
 * Profile (see settings/profile.tsx for the toggle), the
 * _authenticated/index.tsx will redirect here on every fresh signin.
 */
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { FounderDashboardExtended } from '../../../components/dashboard';

function DashboardPage() {
  const navigate = useNavigate();
  return (
    <FounderDashboardExtended
      onOpenCard={(cardId, boardId) => {
        if (boardId) {
          void navigate({
            to: '/board/$boardId/card/$cardId',
            params: { boardId, cardId },
          });
        }
      }}
      onOpenDepartment={(departmentId) =>
        void navigate({
          to: '/departments/$deptKey',
          params: { deptKey: departmentId },
          search: { tab: 'overview' as const },
        })
      }
    />
  );
}

export const Route = createFileRoute('/_authenticated/dashboard/')({
  component: DashboardPage,
});
